export const config = {
  title: "Heather Bays True North Homes LLC | Fathom Realty in Pulaski County, MO",
  meta: {
    description:
      "Heather Bays True North Homes LLC with Fathom Realty provides expert real estate services in Pulaski County, Missouri. Professional home buying, selling, and consultation services in Southwest Missouri and Southeast Kansas.",
    keywords: [
      "Heather Bays True North Homes",
      "Fathom Realty Pulaski County MO",
      "Real Estate Agent Pulaski County Missouri",
      "Home Buying Pulaski County",
      "Home Selling Southwest Missouri",
      "Pulaski County Realtor Services",
      "Missouri Real Estate Agent",
      "Southeast Kansas Properties"
    ],
    author: "Heather Bays True North Homes LLC",
    canonicalUrl: "https://www.heatherbayshomes.com/",
  },
  sections: {
    header: {
      businessName: "Heather Bays True North Homes LLC",
    },
    sectionB: {
      heroTitle: "Your True North for Real Estate in Southwest Missouri",
      heroSubtitle: "Expert Fathom Realty Services in Pulaski County, MO & Surrounding Areas",
      learnAboutText: "Get Your Free Consultation",
      phoneNumber: "5732616383",
      phoneLabel: "(573) 261-6383",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
      cardData: [
        {
          title: "Home Buying Services",
          description:
            "Expert guidance through the home buying process in Pulaski County and Southwest Missouri with local market knowledge and dedicated buyer support.",
        },
        {
          title: "Home Selling Services",
          description:
            "Professional marketing strategies, accurate pricing, and comprehensive selling support to maximize your property value in the local market.",
        },
        {
          title: "Local Market Expertise",
          description:
            "Deep knowledge of Pulaski County, Southwest Missouri, and Southeast Kansas markets with personalized service and community connections.",
        },
      ],
      description:
        "Heather Bays True North Homes LLC, partnered with Fathom Realty, provides exceptional real estate services throughout Pulaski County, Missouri and the surrounding Southwest Missouri and Southeast Kansas areas.",
    },
    sectionC: {
      servicesTitle: "Comprehensive Real Estate Solutions",
      servicesDescription:
        "From first-time home buyers to seasoned investors, we provide personalized service and expert guidance throughout every step of your real estate journey in Southwest Missouri and Southeast Kansas.",
      cards: [
        {
          title: "Buyer Representation",
          description:
            "Complete buyer services including property search, market analysis, negotiation, and transaction management to help you find your perfect home in Pulaski County and surrounding areas.",
          imageSrc: "https://media.istockphoto.com/id/1488170947/photo/magnifying-glass-and-house-model-house-selection-real-estate-concept.jpg?s=612x612&w=0&k=20&c=QUS_3CmxPL9yXPe1WBhqHTy8GcqqjJzO8577lnXNRxs=",
          imageAlt: "Professional real estate buyer consultation in Missouri",
        },
        {
          title: "Seller Representation",
          description:
            "Strategic marketing, professional photography, pricing analysis, and expert negotiation to sell your Southwest Missouri property quickly and for the best possible price.",
          imageSrc: "https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Beautiful Missouri home for sale listing",
        },
        {
          title: "Local Market Knowledge",
          description:
            "Extensive expertise in Pulaski County, Southwest Missouri, and Southeast Kansas markets with detailed area knowledge, pricing trends, and community insights.",
          imageSrc: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Real estate market analysis and consultation",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "First-Time Buyer Programs",
        "Investment Property Analysis",
        "Relocation Services to Missouri",
        "Market Comparative Analysis",
        "New Construction Guidance",
      ],
    },
    sectionD: {
      aboutTitle: "About Heather Bays True North Homes LLC",
      aboutImage: {
        src: "https://www.heatherbayshomes.com/wp-content/uploads/sites/25357/2025/09/Heather-Bays-300x300.png",
        alt: "Heather Bays Professional Real Estate Agent",
      },
      aboutText: [
        "Heather Bays True North Homes LLC, partnered with Fathom Realty, is dedicated to providing exceptional real estate services throughout Pulaski County, Missouri and the greater Southwest Missouri and Southeast Kansas regions. With deep local market knowledge and a commitment to client satisfaction, we guide clients through every aspect of their real estate journey.",
        "Our mission is to be your 'True North' in real estate - providing reliable direction, honest guidance, and professional expertise whether you're buying your first home, selling a property, or exploring investment opportunities in our beautiful Southwest Missouri communities.",
      ],
    },
    sectionE: {
      profileImage: "https://heatherbays.homeseye.com/wp-content/uploads/sites/25357/2025/09/True-North-Homes-LLC-Fathom-Realty.png", // URL or null
      profileAlt: "Heather Bays True North Homes LLC",
      businessName: "Heather Bays True North Homes LLC",
      contact: {
        phone: "5732616383",
        phoneLabel: "(573) 261-6383",
        email: "hb@gonorthorgohome.com",
        website: "https://www.heatherbayshomes.com/",
        address: "Pulaski County, MO",
      },
      socialMedia: {
        bizSolutionsUrl: "https://mybizsolutions.us/biz/heather-bays-true-north-homes-llc-fathom-realty",
        googlePlus: "",
        linkedIn: "",
        facebook: "https://www.facebook.com/heather.bays.1/",
        twitter: "",
        tiktok: "https://www.tiktok.com/@hb_0330?is_from_webapp=1&sender_device=pc",
        instagram: "",
        youtube: "",
        // "" if empty. 
      },
    },
    sectionF: {
      address: "Pulaski County, MO",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d102354.12345678!2d-92.1234567!3d37.8456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87da1234567890ab%3A0x1234567890abcdef!2sPulaski%20County%2C%20MO!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;